import { jsxs as C, jsx as H } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as t } from "./index.es2359.js";
function i({ size: V = t }) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ H("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M23 17.4366C23 17.1605 23.2239 16.9366 23.5 16.9366H32.5C32.7761 16.9366 33 17.1605 33 17.4366V25.9366H37.5C37.7761 25.9366 38 26.1605 38 26.4366V35.4366C38 35.7128 37.7761 35.9366 37.5 35.9366H18.5C18.2239 35.9366 18 35.7128 18 35.4366V26.4366C18 26.1605 18.2239 25.9366 18.5 25.9366H23V17.4366Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M27 16.9366C26.4477 16.9366 26 17.3844 26 17.9366V19.9366C26 20.4889 26.4477 20.9366 27 20.9366H29C29.5523 20.9366 30 20.4889 30 19.9366V17.9366C30 17.3844 29.5523 16.9366 29 16.9366H27Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M35.5 40.9366H40.5C40.776 40.9366 41 40.7126 41 40.4366V35.4366C41 35.1606 40.776 34.9366 40.5 34.9366H15.5C15.224 34.9366 15 35.1606 15 35.4366V40.4366C15 40.7126 15.224 40.9366 15.5 40.9366H20.5C20.776 40.9366 21 40.7126 21 40.4366V38.9366H25V40.4366C25 40.7126 25.224 40.9366 25.5 40.9366H30.5C30.776 40.9366 31 40.7126 31 40.4366V38.9366H35V40.4366C35 40.7126 35.224 40.9366 35.5 40.9366Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M21 26.9366C21 26.3844 21.4477 25.9366 22 25.9366H24C24.5523 25.9366 25 26.3844 25 26.9366V28.9366C25 29.4889 24.5523 29.9366 24 29.9366H22C21.4477 29.9366 21 29.4889 21 28.9366V26.9366Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M32 25.9366C31.4477 25.9366 31 26.3844 31 26.9366V28.9366C31 29.4889 31.4477 29.9366 32 29.9366H34C34.5523 29.9366 35 29.4889 35 28.9366V26.9366C35 26.3844 34.5523 25.9366 34 25.9366H32Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M33 17.4366V25.9366H37.5C37.7761 25.9366 38 26.1605 38 26.4366V34.9366H40.5C40.776 34.9366 41 35.1606 41 35.4366V40.4366C41 40.7126 40.776 40.9366 40.5 40.9366H35.5C35.224 40.9366 35 40.7126 35 40.4366V38.9366H31V40.4366C31 40.7126 30.776 40.9366 30.5 40.9366H25.5C25.224 40.9366 25 40.7126 25 40.4366V38.9366H21V40.4366C21 40.7126 20.776 40.9366 20.5 40.9366H15.5C15.224 40.9366 15 40.7126 15 40.4366V35.4366C15 35.1606 15.224 34.9366 15.5 34.9366H18V26.4366C18 26.1605 18.2239 25.9366 18.5 25.9366H23V17.4366C23 17.1605 23.2239 16.9366 23.5 16.9366H32.5C32.7761 16.9366 33 17.1605 33 17.4366ZM24 17.9366V25.9366H32V17.9366H30V19.9366C30 20.4889 29.5523 20.9366 29 20.9366H27C26.4477 20.9366 26 20.4889 26 19.9366V17.9366H24ZM19 34.9366H27.5V26.9366H25V28.9366C25 29.4889 24.5523 29.9366 24 29.9366H22C21.4477 29.9366 21 29.4889 21 28.9366V26.9366H19V34.9366ZM28.5 34.9366H37V26.9366H35V28.9366C35 29.4889 34.5523 29.9366 34 29.9366H32C31.4477 29.9366 31 29.4889 31 28.9366V26.9366H28.5V34.9366ZM16 35.9366V39.9366H20V37.9366H26V39.9366H30V37.9366H36V39.9366H40V35.9366H16ZM34 26.9366V28.9366H32V26.9366H34ZM24 26.9366H22V28.9366H24V26.9366ZM27 17.9366H29V19.9366H27V17.9366Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricUnmetDemandIcon
};
//# sourceMappingURL=index.es411.js.map
